var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCalc(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax_bold_calculator",
    "data-name": "vuesax/bold/calculator",
    transform: "translate(-300 -252)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M13,0H5A5,5,0,0,0,0,5V15a5,5,0,0,0,5,5h8a5,5,0,0,0,5-5V5A5,5,0,0,0,13,0ZM5.86,16.63a1,1,0,0,1-1.41,0,1,1,0,0,1-.3-.71,1.017,1.017,0,0,1,.3-.71A.988.988,0,0,1,4.77,15a1.026,1.026,0,0,1,.77,0,.556.556,0,0,1,.17.09.609.609,0,0,1,.15.12,1.017,1.017,0,0,1,.3.71A1,1,0,0,1,5.86,16.63ZM4.15,11.92a1,1,0,0,1,.08-.38.911.911,0,0,1,.22-.33,1,1,0,0,1,.9-.27.7.7,0,0,1,.19.06.556.556,0,0,1,.17.09.609.609,0,0,1,.15.12,1.06,1.06,0,0,1,.22.33,1,1,0,0,1-.92,1.38,1.006,1.006,0,0,1-.39-.08.988.988,0,0,1-.32-.21A1,1,0,0,1,4.15,11.92Zm5.71,4.71a.988.988,0,0,1-.32.21,1.007,1.007,0,0,1-.39.08.984.984,0,0,1-.7-.29,1,1,0,0,1-.3-.71,1.355,1.355,0,0,1,.02-.2l.06-.18.09-.18a1.738,1.738,0,0,1,.13-.15A.988.988,0,0,1,8.77,15a1.017,1.017,0,0,1,1.09.21,1.007,1.007,0,0,1,.29.71A.99.99,0,0,1,9.86,16.63Zm0-4a1.005,1.005,0,0,1-1.71-.71,1.017,1.017,0,0,1,.3-.71,1.034,1.034,0,0,1,1.41,0,1.06,1.06,0,0,1,.22.33,1.03,1.03,0,0,1-.22,1.09ZM6,8.46A1.884,1.884,0,0,1,4.12,6.58v-1A1.884,1.884,0,0,1,6,3.7h6a1.884,1.884,0,0,1,1.88,1.88v1A1.884,1.884,0,0,1,12,8.46Zm7.86,8.17a1,1,0,0,1-1.7-.71A.99.99,0,0,1,13.54,15a.988.988,0,0,1,.32.21,1.007,1.007,0,0,1,.29.71A.99.99,0,0,1,13.86,16.63Zm.22-4.33a1,1,0,0,1-.22.33,1.005,1.005,0,0,1-1.71-.71,1.017,1.017,0,0,1,.3-.71,1.034,1.034,0,0,1,1.41,0,1.017,1.017,0,0,1,.3.71A1,1,0,0,1,14.08,12.3Z",
    transform: "translate(303 254)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-2",
    "data-name": "Vector",
    d: "M0,0H24V24H0Z",
    transform: "translate(324 276) rotate(180)",
    fill: "none",
    opacity: 0
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalc);
export default __webpack_public_path__ + "static/media/calc.54e91b938368bec2c41e19444f41f486.svg";
export { ForwardRef as ReactComponent };